import React from 'react'
import { Steps, Row, Col ,Divider} from 'antd'
import StepsIcon from 'components/icons/StepsIcon'
import StepsCompleted from 'components/icons/StepsCompleted'
import EmptyCircle from 'components/icons/EmptyCircle'
import StepRejected from 'components/icons/StepRejected'
import styled from 'styled-components'
import CustomTag from 'components/CustomTag'
const { Step } = Steps


const StyledStep = styled(Step)`
  .ant-steps-item-title {
    width: 100% !important;
  }
`
const StyledDivider = styled(Divider)`
margin: 5px;
`
const StyleRow = styled(Row)`
    padding: 0px 5px 25px 5px;
    width: 250px;
    margin-bottom: -10px;
`

const StyleDiv = styled.div`
float: right;
padding: 5px;
`
const TextDiv = styled.div`
font-size: 16px;
font-weight: 400;
line-height: 24px;
color: #000000;
`
const iconCheck = value => {

 
  if (value === 'SCHEDULED') {
    return <StepsIcon />
  }
  if (value === 'SHORTLISTED') {
    return <StepsIcon />
  }
  if (value === 'SELECTED') {
    return   <StepsCompleted />
  }
  if (value === 'REJECTED') {
    return <StepRejected />
  }
}
const titleCheck = title => {

  if (title === 'SHORTLISTED') {
    return (
      <CustomTag
        message={'Shortlisted'}
        bordered={true}
        background="#DFF0EA"
        colorType="#5DB594"
        border="#DFF0EA"
      />
    )
  }
  if (title === 'SCHEDULED') {
    return (
      <CustomTag
        message={'Scheduled'}
        bordered={true}
        background="#DFF0EA"
        colorType="#5DB594"
        border="#DFF0EA"
      />
    )
  }
  if (title === 'SELECTED') {
    return (
      <CustomTag
        message={'Selected'}
        bordered={true}
        background="#DFF0EA"
        colorType="#5DB594"
        border="#DFF0EA"
      />
    )
  }
  if (title === 'REJECTED') {
    return (
      <CustomTag
        message={'Rejected'}
        bordered={true}
        background="#FDF2F1"
        colorType="#E97E73"
        border="#FDF2F1"
      />
    )
  }
  if (title === 'HELD_TO_COMPARE') {
    return (
      <CustomTag
        message={'On Hold'}
        bordered={true}
        background="#FEF8F3"
        colorType="#F3A66E"
        border="#FEF8F3"
      />
    )
  }
}
const CustomSteps = ({
  steps,
  direction = 'vertical',
  size = 'small',
  current,
  currentStatus,
  ...props
}) => {
 
  return (
 
      <Steps direction={direction} size={size} current={current} {...props}>
        {steps?.map((step, index) => (
          <StyledStep
            key={index+"stepIcon"}
            icon={

              current > step?.activeKey ? (
                <StepsCompleted />
              ) : step?.activeKey == current ? iconCheck(currentStatus) : (
                <EmptyCircle />
              )
            }
            title={
              <StyleRow>
                <Col span={12}>
                  <TextDiv>{step.roundNumber}</TextDiv>
                  <TextDiv>{step.roundName}</TextDiv>
                </Col>
                <Col span={12}>
                  <StyleDiv>
                    { current > step?.activeKey ? (
               <CustomTag
               message={'Shortlisted'}
               bordered={true}
               background="#DFF0EA"
               colorType="#5DB594"
               border="#DFF0EA"
             />
              ) : step?.activeKey == current ? titleCheck(currentStatus) : null}
                  </StyleDiv>
                </Col>
              </StyleRow>
            }
          />
        ))}
      </Steps>

  )
}

export default CustomSteps
